import { CustomTemplate } from 'types/template';
import WizardButtonWrapper from '../../Wizard/WizardButtonWrapper';
import TemplateReview from '../TemplateReview';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';

interface LaunchCustomTemplateProps {
  selectedTemplate: CustomTemplate;
  onModalClose: () => void;
  onLaunch: () => void;
  onSave: () => void;
}

export default function LaunchCustomTemplate({
  selectedTemplate,
  onModalClose,
  onLaunch,
  onSave,
}: LaunchCustomTemplateProps) {
  return (
    <>
      <TemplateReview
        description={selectedTemplate.description}
        channels={selectedTemplate.channels}
        label={selectedTemplate.label}
      />

      <WizardButtonWrapper onModalClose={onModalClose}>
        <StylishNewButton className="button--secondary ms-2" onClick={onSave}>
          Save
        </StylishNewButton>
        <StylishNewButton
          className="button--secondary ms-2"
          onClick={() => {
            onSave();
            onLaunch();
          }}
        >
          Save & Launch
        </StylishNewButton>
        <StylishNewButton className="button--primary ms-2" onClick={onLaunch}>
          Launch
        </StylishNewButton>
      </WizardButtonWrapper>
    </>
  );
}
